export default {
   'features': '기능',
   'downloads': '다운로드',
   'roadmap': '로드맵',
   'price': '가격',
   'donate': '기부',
   'feedback': '피드백',
   'panel': '제어판',
};
